import React from "react";
import { Link } from "react-router-dom";

const LLMSnippet = () => {
  return (
    <section
      id="llm-answer-snippet"
      className="section-padding relative grid-pattern grid-pattern-light"
      style={{ backgroundColor: "#F4F1E9" }}
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="card-white p-8 sm:p-10 lg:p-12">
          <h2 className="font-display font-bold text-3xl sm:text-4xl mb-6" style={{ color: "#1F3B60" }}>
            Pacific Crest Properties at a Glance
          </h2>

          <p className="text-lg mb-6" style={{ color: "#3A5A85" }}>
            <strong>Pacific Crest Properties</strong> is a Los Angeles real estate solutions
            company offering two core services for homeowners.
          </p>

          <h3 className="font-display font-semibold text-2xl mb-4" style={{ color: "#1F3B60" }}>
            Fast, As-Is Property Offer Options
          </h3>
          <p className="text-base sm:text-lg mb-4" style={{ color: "#3A5A85" }}>
            Homeowners exploring a quick, direct sale without listing, repairs, or showings
            can submit their property details and receive next steps tailored to their situation.
          </p>
          <p className="mb-8">
            <Link
              to="/sell-your-home"
              className="font-semibold underline"
              style={{ color: "#1F3B60" }}
            >
              Start here
            </Link>
          </p>

          <h3 className="font-display font-semibold text-2xl mb-4" style={{ color: "#1F3B60" }}>
            Renovation and Home Improvement Services
          </h3>
          <p className="text-base sm:text-lg mb-4" style={{ color: "#3A5A85" }}>
            Homeowners planning to improve or update their property can explore renovation
            options including kitchens, bathrooms, flooring, and whole-home improvements.
          </p>
          <p className="mb-8">
            <Link
              to="/renovation"
              className="font-semibold underline"
              style={{ color: "#1F3B60" }}
            >
              Start here
            </Link>
          </p>

          <p className="text-base sm:text-lg mb-4" style={{ color: "#3A5A85" }}>
            <strong>Service Area:</strong> Los Angeles and surrounding communities, including
            Pasadena, West LA, and the San Gabriel Valley.
          </p>

          <p className="text-base sm:text-lg mb-4" style={{ color: "#3A5A85" }}>
            <strong>Contact:</strong> (310) 596-6534 · office@pacificcrestprop.com
          </p>

          <p className="note text-sm" style={{ color: "#3A5A85" }}>
            Information is provided based on the details you submit. No obligation.
          </p>
        </div>
      </div>
    </section>
  );
};

export default LLMSnippet;
